import React,{useState, useEffect} from 'react'
import { HeaderAdmin } from "../../components/HeaderAdmin/HeaderAdmin";
import { LateralMenu } from "../../components/LateralMenu/LateralMenu";
import { Link, useHistory } from 'react-router-dom';
import { API } from '../../../services/api';
import ImgLoading from '../../../assets/cargacaleta.gif';
import "./StaffList.scss";

export function StaffListPage() {
  /**
   * Vista de usuarios administradores
   * Se consulta el listado de los usuarios administradores al servidor
   */
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const protectedRoute = ()=>{
    const sessionToken = localStorage.getItem('sessionToken');
    if(!sessionToken){
      history.push('/staff-login')
    }
  }

  useEffect(() => {
    protectedRoute();
    setLoading(true);
    /**
     * Obtener usuarios administradores
     * Se hace el llamado al servicio /staffusers/get-staff-users-list
     */
    API.getStaffUsersList()
      .then(res => {
        setUsers(res);
        setLoading(false);
      })
      .catch(err => {
        setUsers([]);
        setLoading(false);
      })
  }, []);

  const removeStaff = async(id)=>{
    const result = window.confirm('Remover usuario?')
    if(result){
      setLoading(true);
      /**
       * Eliminar usuario administrador
       * Se hace el llamado al servicio /staffusers/remove-staff-user
       */
      await API.putRemoveStaffUser(id);
      /**
       * Obtener usuarios administradores
       * Se hace el llamado al servicio /staffusers/get-staff-users-list
       */
      API.getStaffUsersList()
        .then(res => {
          setUsers(res);
          setLoading(false);
        })
        .catch(err => {
          setUsers([]);
          setLoading(false);
        })
    }
  }

  if(loading){
    return <>
      <HeaderAdmin />
      <LateralMenu />
      <main className='content-img'>
        <img className='img-loading' src={ImgLoading} alt="" />
      </main>
    </>
  }

  return (
    <>
      <HeaderAdmin />
      <LateralMenu />
      <main className="content">
        <h2>Usuarios</h2>
        <Link 
          to={{pathname:'register-staff'}}
          className='button-r'>Registrar Usuario</Link>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                users.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>
                      <button 
                        className='button-remove'
                        onClick={()=>removeStaff(item._id)}>
                        Remover</button>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </main>
    </>
  )
}
